/**
 * reportOptimize模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const reportOptimize = {
  //资源优化添加
  addReportOptimize(params) {
    return $http.post(`${global.API_URL}/sme/reportOptimize/add`,params);
  },
  //资源优化删除
  deleteReportOptimize(params) {
    return $http.post(`${global.API_URL}/sme/reportOptimize/delete`,params);
  },
  //查询资源优化列表
  selectOptimizeList(params) {
    return $http.post(`${global.API_URL}/sme/reportOptimize/selectOptimizeList`,params, {
      timeout: 1000 * 60 * 20 // 接口响应事件设置为：20min
    });
  },
  //查询运维报告资源优化列表
  selectReportOptimizeList(params) {
    return $http.post(`${global.API_URL}/sme/reportOptimize/selectReportOptimizeList`,params, {
      timeout: 1000 * 60 * 20 // 接口响应事件设置为：20min
    });
  }
}

export default reportOptimize;



// WEBPACK FOOTER //
// ./src/api/reportOptimize.js